import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GetRestaurants } from '../api/restaurant';
import {UsersForUpdate} from '../api/users'
import { GetPosts, GetAccessPosts } from '../api/post'; 
import { UpdateUser } from '../api/users'



const Users = ({ token }) => {
    const [restaurants, setRestaurants] = useState([])
    const [sync, setSync] = useState(true)
    const [selectedRestaurant, setSelectedRestaurant] = useState(0)
    const [dataInput, setDataInput] = useState('')
    const [allUsers, setAllUsers] = useState([])
    const [allPosts, setAllPosts] = useState([])
    const [postsDict, setPostsDict] = useState([])
    const [restaurantsDict, setRestaurantsDict] = useState({})
    const [selectedUser, setSeletedUser] = useState({})
    const [userRestaurant, setUserRestaurant] = useState(0)
    const [userPost, setUserPost] = useState(0)
    const [userSync, setUserSync] = useState(false)
    const [userNewPassword, setUserNewPassword] = useState('')
    const [message, setMessage] = useState('')
    



    const fetchAllRestaurants = async () => {
        try {
            const data = await GetRestaurants(token, 1, 50)
            setRestaurants(data.data)
            const posts = await GetAccessPosts(token)
            setAllPosts(posts)
            let dict = {}
            console.log(posts)
            for (let post of posts){
                dict[post.id] = post
            }
            setPostsDict(dict)
            let restaurantsDict = {}
            for (let rest of data.data){
                restaurantsDict[rest.id] = rest
            }
            setRestaurantsDict(restaurantsDict)

        }
        catch (error){
            console.log(error)
        }
    }
    
    useEffect(() => {
            fetchAllRestaurants();
        }, [token]);
    

    async function selectRestaurant(event) {
        const value = event.target.value
        setSelectedRestaurant(value)
    }

    async function inputDataUser(event) {
        const value = event.target.value
        setDataInput(value)
        const data = await UsersForUpdate(token, selectedRestaurant, value, sync)
        setAllUsers(data)
    }

    async function selectUser(e, user) {
        setUserRestaurant(user.restaurant_id)
        setUserPost(user.post_id)
        setUserSync(user.syncing_with_bk)
        setSeletedUser(user)
        setMessage()
        setUserNewPassword('')
    }

    async function selectRestaurantUser(e) {
        setUserRestaurant(e.target.value)
        
    }

    async function selectPostUser(e) {
        setUserPost(e.target.value)
    }

async function updateUser(e) {

    let pass = null
    if (userNewPassword != ''){
        pass = userNewPassword
    }
    const data = await UpdateUser(token, {
        id: selectedUser.id, 
        post_id: userPost, 
        restaurant_id: userRestaurant, 
        syncing_with_bk: userSync,
        hashed_password: pass
    });
    if (data.detail){
        setMessage(<p style={{color: 'red'}}>{data.detail}</p>)
        return
    }
    setAllUsers(prevUsers => prevUsers.map(user => 
        user.id === data.id ? data : user
    ));
    setMessage(<p style={{color: 'green'}}>Успешно!</p>)
}

  return (
    <div className="container" style={{marginTop: "5%"}}>
        <div className="row">
            <div className="col-sm-2">
                <p>Фамилия Сотрудника</p>
            </div>
            <div className="col-sm-10">
                <input type="text" className='form-control' onChange={inputDataUser}/>
            </div>
            <div className="col-sm-2">
                <p>Ресторан</p>
            </div>
            <div className="col-sm-10">
                <select className="form-select" aria-label="Пример выбора по умолчанию" value={selectedRestaurant} onChange={selectRestaurant}>
                        <option value={0} key={0}>Все</option>

                    {restaurants.map(rest => (
                        <option value={rest.id} key={rest.id}>{rest.name}</option>
                    ))}
                </select>
            </div>
            <div className="col-sm-2">
                Синхронизируется
            </div>
            <div className="col-sm-10">
                <input className="form-check-input" type="checkbox" checked={sync} onChange={(e) => setSync(e.target.checked)} id="flexCheckIndeterminate"></input>
            </div>

        

        </div>
        <div className="row">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Имя</th>
                        <th>Фамилия</th>
                        <th>Должность</th>
                        <th>Ресторан</th>
                        <th>Синхронизация</th>
                    </tr>
                </thead>
                <tbody>
                    {allUsers.map( user => (
                         <tr data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={(e) => selectUser(e.stopPropagation(), user)}>

                            <td>{user.id}</td>
                            <td>{user.name}</td>
                            <td>{user.surname}</td>
                            <td>{postsDict[user.post_id].name}</td>
                            <td>{restaurantsDict[user.restaurant_id].name}</td>
                            <td>{user.syncing_with_bk ? '✓' : '✗'}</td>
                        </tr>
                    )
                       
                    )}
                </tbody>
            </table>
        </div>
        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Редактирование сотрудника</h1>
                </div>
                <div className="modal-body">
                    <div className="row" >
                        <div className="col-sm-4">Фамилия</div>
                        <div className="col-sm-8 text-center">{selectedUser.surname}</div>
                    </div>
                    <div className="row" style={{marginTop: "3%"}}>
                        <div className="col-sm-4">Имя</div>
                        <div className="col-sm-8 text-center">{selectedUser.name}</div>
                    </div>
                    <div className="row" style={{marginTop: "3%"}}>
                        <div className="col-sm-4">Ресторан</div>
                        <div className="col-sm-8 text-center">
                            <select className="form-select" aria-label="Пример выбора по умолчанию" value={userRestaurant} onChange={selectRestaurantUser}>
                                {restaurants.map(rest => (
                                    <option value={rest.id} key={rest.id}>{rest.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "3%"}}>
                        <div className="col-sm-4">Должность</div>
                        <div className="col-sm-8">
                            <select className="form-select" aria-label="Пример выбора по умолчанию" value={userPost} onChange={selectPostUser}>
                                {allPosts.map(post => (
                                    <option value={post.id} key={post.id}>{post.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "3%"}}>
                        <div className="col-sm-4">Новый пароль</div>
                        <div className="col-sm-8">
                            <input type="text" className='form-control'  value={userNewPassword} onChange={(e) => setUserNewPassword(e.target.value)}></input>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "3%"}}>
                        <div className="col-sm-4">Синхронизация</div>
                        <div className="col-sm-8">
                            <input className="form-check-input" type="checkbox" checked={userSync} onChange={(e) => setUserSync(e.target.checked)} id="flexCheck"></input>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 text-center">
                            {message}
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn " data-bs-dismiss="modal">Закрыть</button>
                    <button type="button" className="btn " onClick={updateUser}>Сохранить изменения</button>
                </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Users;
